namespace GeniuzPOS.AdvPromo {
    export enum PromoShopFg {
        allshop = 0,
        chshop = 1
    }
    Serenity.Decorators.registerEnumType(PromoShopFg, 'GeniuzPOS.AdvPromo.PromoShopFg');
}
